export default "__VITE_ASSET__1Hzrk4O8__"